<template>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="projectsWithLimits"
    :search="searchBy"
    height="calc(100vh - 48px)"
    fixed-header
    :items-per-page="-1"
    hide-default-footer
  >
    <template #body.prepend>
      <payout-limit-editor
        v-if="isAddingNewItem"
        :entities="configurableEntities"
        @save="$emit('save', $event)"
        @close="isAddingNewItem = false"
      />
    </template>
    <template #header.action>
      <v-text-field
        v-model="searchBy"
        class="font-weight-regular mr-2 d-inline-flex flex-grow-0"
        clearable
        :disabled="!projectsWithLimits.length"
        label="Search"
        hide-details
        append-icon="search"
      />
      <v-btn @click="$emit('reload', $event)" icon>
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn
        v-if="projectsWithoutLimits.length"
        icon
        @click="isAddingNewItem = true"
      >
        <v-icon>
          add
        </v-icon>
      </v-btn>
    </template>
    <template #item="{item}">
      <component
        :is="getItemComponent(item.entity_id)"
        :limit="item"
        @edit="editingProjectId = $event"
        @save="$emit('save', $event)"
        @close="editingProjectId = null"
        @delete="$emit('delete', $event)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { partition } from 'lodash'
import PayoutLimitEditor from './PayoutLimitEditor.vue'
import PayoutLimitView from './PayoutLimitView.vue'

export default {
  components: {
    PayoutLimitEditor,
  },
  props: {
    entities: {
      type: Array,
      required: false,
    },
    isLoading: Boolean,
    limits: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Project', value: 'name' },
        { text: 'Daily Limit', value: 'payout_limits.daily_limit' },
        { text: 'Weekly Limit', value: 'payout_limits.weekly_limit' },
        { text: 'Monthly Limit', value: 'payout_limits.monthly_limit' },
        { text: '', value: 'action', sortable: false, align: 'end' },
      ],
      editingProjectId: null,
      isAddingNewItem: false,
      searchBy: '',
    }
  },

  computed: {
    projectGroups() {
      return partition(this.limits, project => !!Object.keys(project.payout_limits).length)
    },
    projectsWithLimits() {
      return this.projectGroups[0]
    },
    projectsWithoutLimits() {
      return this.projectGroups[1]
    },
    configurableEntities() {
      return this.projectsWithoutLimits.map(project => ({text: project.name, value: project.entity_id}))
    },
  },

  methods: {
    getItemComponent(entity_id) {
      return this.editingProjectId === entity_id ? PayoutLimitEditor : PayoutLimitView
    }
  },

  watch: {
    isLoading(yes) {
      if (!yes) {
        this.isAddingNewItem = false
        this.editingProjectId = null
      }
    }
  }
}
</script>
